// firebase-messaging.js
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { app } from "./firebase";

// Utilise l'instance Firebase déjà initialisée (voir src/firebase.js)
const messaging = getMessaging(app);

// Fonction pour demander la permission et récupérer le token
export async function requestNotificationToken() {
  const permission = await Notification.requestPermission();

  if (permission === "granted") {
    // Récupère le Service Worker déjà enregistré (par index.html)
    const swRegistration = await navigator.serviceWorker.ready;

    // Vérifie que le SW contient bien la logique FCM
    if (!swRegistration.active) {
      console.warn("[FCM] Service Worker pas encore activé, attente...");
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }

    // VAPID key correcte (récupérée de Firebase Console)
    try {
      const token = await getToken(messaging, {
        vapidKey:
          "BHaGAdEcb6yukLdzlBJ60gwWr5JkVMToot_q-IvaXpmtaozvAEkAMjPcrjggOagYqPPqLPKdY2L2Kjwu9Ydc2Fg",
        serviceWorkerRegistration: swRegistration,
      });

      console.log("[FCM] Token généré avec succès");
      return token;
    } catch (error) {
      console.error("[FCM] Erreur lors de la génération du token:", error);
      throw error;
    }
  } else {
    throw new Error("Permission refusée pour les notifications");
  }
}

// Ecoute les notifications reçues en premier plan
// Le Service Worker (sw.js) affiche déjà la notification native via onBackgroundMessage.
// On évite donc d'en créer une deuxième ici pour ne pas avoir de doublon.
onMessage(messaging, (payload) => {
  if (payload.notification) {
    console.log(
      "[FCM Foreground] Notification reçue (déjà affichée par le SW) :",
      payload.notification.title,
      payload.notification.body,
    );
  }
});

// Export global pour le debug depuis la console
if (typeof window !== "undefined") {
  window.requestNotificationToken = requestNotificationToken;
  window.firebaseMessaging = messaging;
  console.log("[FCM] Fonctions exportées globalement pour le debug");
}
